<template>
  <div class="columns is-multiline">
    <div class="column is-12 has-text-primary is-italic is-size-5">
      {{ $t('addEditOrdreTravailTech.patrimoine.materiel.champs.title') }}
    </div>
    <b-field :label="$t('addEditOrdreTravailTech.patrimoine.materiel.champs.passerelle')"
             class="column is-3 mgb-0 pdt-0">
      <b-checkbox v-model="materielTechnique.passerelle"></b-checkbox>
    </b-field>
    <b-field :label="$t('addEditOrdreTravailTech.patrimoine.materiel.champs.typeEclairage')"
             class="column is-3 mgb-0 pdt-0">
      <b-input v-model="materielTechnique.typeEclairage"></b-input>
    </b-field>
    <b-field :label="$t('addEditOrdreTravailTech.patrimoine.materiel.champs.largeur')"
            class="column is-3 mgb-0 pdt-0">
      <input-currency v-model="materielTechnique.largeur"
                      isNumber="true">
      </input-currency>
    </b-field>
    <b-field :label="$t('addEditOrdreTravailTech.patrimoine.materiel.champs.longueur')"
      class="column is-3 mgb-0 pdt-0">
      <input-currency v-model="materielTechnique.longueur"
                      isNumber="true">
      </input-currency>
    </b-field>
  </div>
</template>

<script>
import inputCurrency from '@/components/general/inputCurrency';

export default {
  props: {
    materielTechnique: {
      type: Object,
      required: true,
    },
  },
  components: {
    inputCurrency,
  },
};

</script>
